/**
 * KPIs the customer can include in an executive PDF.
 * Default export selects every id.
 */
export const REPORT_GRAINS = Object.freeze({
	MONTH: 'month',
	WEEK: 'week',
})

export const WEEK_STARTS = Object.freeze({
	SUNDAY: 'sunday',
	MONDAY: 'monday',
})

export const EXECUTIVE_REPORT_KPIS = [
	{
		id: 'avgScore',
		labelKey: 'er_metric_avg_score',
		comparisonMetricKeys: ['er_metric_avg_score'],
		findingIds: ['avg_score'],
	},
	{
		id: 'responseTime',
		labelKey: 'er_metric_avg_response_time',
		comparisonMetricKeys: ['er_metric_avg_response_time'],
		findingIds: ['response_time'],
	},
	{
		id: 'cleanerArrivals',
		labelKey: 'er_metric_cleaner_arrivals',
		comparisonMetricKeys: ['er_metric_cleaner_arrivals'],
	},
	{
		id: 'supervisorInspections',
		labelKey: 'er_metric_supervisor_inspections',
		comparisonMetricKeys: ['er_metric_supervisor_inspections'],
	},
	{
		id: 'expiredSlas',
		labelKey: 'er_metric_expired_slas',
		comparisonMetricKeys: ['er_metric_expired_slas'],
	},
	{
		id: 'complaints',
		labelKey: 'er_metric_complaints',
		comparisonMetricKeys: ['er_metric_complaints'],
	},
	{
		id: 'visits',
		labelKey: 'er_metric_customer_visits',
		comparisonMetricKeys: ['er_metric_customer_visits'],
	},
	{
		id: 'complaintsVsVisits',
		labelKey: 'er_metric_complaints_vs_visits_pct',
		comparisonMetricKeys: ['er_metric_complaints_vs_visits_pct'],
		findingIds: ['complaints_ratio'],
	},
	{
		id: 'complaintDrivers',
		labelKey: 'er_page_complaint_drivers',
	},
	{
		id: 'roomTable',
		labelKey: 'er_page_rooms',
	},
]

export const ALL_EXECUTIVE_REPORT_KPI_IDS = EXECUTIVE_REPORT_KPIS.map((kpi) => kpi.id)

export function defaultExecutiveKpiSelection() {
	return ALL_EXECUTIVE_REPORT_KPI_IDS.reduce((acc, id) => {
		acc[id] = true
		return acc
	}, {})
}

function mapKpiReferences(field) {
	return EXECUTIVE_REPORT_KPIS.reduce((map, kpi) => {
		(kpi[field] || []).forEach((key) => {
			map[key] = kpi.id
		})
		return map
	}, {})
}

export const COMPARISON_ROW_KPI = mapKpiReferences('comparisonMetricKeys')
export const FINDING_KPI = mapKpiReferences('findingIds')
